import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import useRequest from 'hooks/use-request';
import {API_GET_TOURISTIC_SITE, API_GET_TOURISTIC_SITE_DETAILS, API_GET_TOURISTIC_SITES} from 'utils/api';
import {ImageURL} from 'utils/texts';

// Réplique volontairement le chargement de NewTouristicSiteWithProviders
// (NewTouristicSite.jsx) sans le modifier : ce fichier est une dépendance de
// l'iframe admin et ne doit pas bouger.
const useTouristicSiteDetailsV3 = (touristicSiteId) => {
  const config = useSelector(state => state.data);
  const [handleRequest] = useRequest();
  const [site, setSite] = useState();
  const [nearby, setNearby] = useState([]);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setSite(undefined);
    setNearby([]);
    setNotFound(false);

    handleRequest('get', API_GET_TOURISTIC_SITE_DETAILS(touristicSiteId, localStorage.getItem('resourceAccessToken')), {}, config, (data, status) => {
      if (status === 'Done') {
        setSite(state => ({
          ...state,
          tickets: data.tickets || [],
          activities: (data.activities || []).map(el => ({
            ...el,
            feedbacks: {note: el.avg_note || 5, comments: [], len: el.notes_counter},
          })),
          events: (data.events || []).map(el => ({
            ...el,
            images: [{picture: ImageURL + '/touristic_site/event/' + (el.touristic_site_event_image && el.touristic_site_event_image.image)}],
          })),
        }));
      } else if (status === 'Error') {
        console.error(data);
        setNotFound(true);
      }
    });

    handleRequest('get', API_GET_TOURISTIC_SITE(touristicSiteId), {}, config, (data, status) => {
      if (status === 'Done') {
        setSite(state => ({
          ...state,
          ...data,
          category: data.categories[0] || {
            color: '#EF7E26',
            id: 53,
            title: 'Activité',
            url: 'https://general-henri-1-paris.s3.fr-par.scw.cloud/categories/activites_sportives.jpg',
          },
          henri_certified: !!data.agency_id,
          feedbacks: {
            note: data.avg_note,
            comments: data.touristic_site_reviews,
            len: data.notes_counter,
          },
        }));
      } else if (status === 'Error') {
        console.error(data);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [touristicSiteId]);

  useEffect(() => {
    if (!site || !site.latitude || !site.longitude || nearby.length > 0) {
      return;
    }
    handleRequest('get', API_GET_TOURISTIC_SITES(site.longitude, site.latitude, undefined, undefined, 9), {}, config, (data, status) => {
      if (status === 'Done') {
        setNearby(
          (data || [])
            .filter(el => el.id !== site.id)
            .slice(0, 8)
        );
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site && site.id, site && site.latitude]);

  return {site, nearby, notFound};
};

export default useTouristicSiteDetailsV3;
